import {
  Component,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

export type DsStatusPillTone =
  | 'default'
  | 'success'
  | 'accent'
  | 'warning'
  | 'danger'
  | 'muted';

@Component({
  selector: 'ds-status-pill',
  templateUrl: 'ds-status-pill.component.html',
  styleUrls: ['ds-status-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DsStatusPillComponent {
  @Input() label = '';
  @Input() tone: DsStatusPillTone = 'default';
}
